export default __webpack_public_path__ + "static/media/masar.fbf8907f.jpg";